import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LendersService } from '../../services/lenders.service';
import { UserService } from 'app/core/services/user.service';
import { Result } from 'app/core/models/result';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { LendersModel } from '../../models/lenders.model';
import { LenderUserModel } from '../../models/lender-user.model';
import { NewUser } from '../../../account/models/new-user.model';
import { LenderContactModel } from '../../models/lender-contact.model';

@Component({
  selector: 'app-lenders-contact',
  templateUrl: './lenders-contact.component.html',
  styleUrls: ['./lenders-contact.component.css']
})
export class LendersContactComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    lenderId: string;
    lender: LendersModel;
    isEditMode = false;
    lenderContacts: LenderUserModel[];
    isEmailValid: boolean;
    newUser: NewUser;
    exUser: LenderUserModel;
    lenderContact: LenderContactModel;
    showContactAddForm: boolean = false;
    showContactEditForm: boolean = false;
    showContactDetails: boolean = false;
    isDeleteMode: boolean = false;
    infoMessage: boolean = false;
    infoMessageText: string;

    constructor(
        private lendersService: LendersService,
        private accountService: UserService,
        private fb: FormBuilder,
        private location: Location,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        this.load();
    }

    load() {
        this.newUser = {
            isLender: true
        } as NewUser;
        this.isEmailValid = true;
        this.lenderId = this.activatedRoute.snapshot.params['id'];
        this.lendersService.get(this.lenderId).subscribe(lender => {
            this.headerTitle = {
                title: lender.name, breadcrumbs: [
                    { title: 'Lenders', url: ['/lenders'] }
                ]
            }
            this.getContacts(lender.id);
        });
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }
    toggleDeleteMode(): void {
        this.isDeleteMode = !this.isDeleteMode;
    }

    onBack(): void {
        this.location.back();
    }

    getContacts(lenderId: string): void {
        this.lendersService.getContacts(lenderId).subscribe(result => {
            this.lenderContacts = result;
            this.showContactAddForm = this.lenderContacts.length == 0;
            this.showContactDetails = this.lenderContacts.length > 0
        });
    }

    checkEmail(): void {
        const existsSubscription = this.accountService.existsUserByEmail(this.newUser.email).subscribe(
            result => {
                this.isEmailValid = !result;
                existsSubscription.unsubscribe();
            }
        );
    }

    registerUserToLender(): void {
        this.submitAttempt = true;
        this.accountService.registerUser(this.newUser).subscribe(
            result => {
                this.submitAttempt = false;

                if (this.lenderId) {
                    this.lenderContact = {
                        lenderId: this.lenderId,
                        siteUserId: result,
                        isActive: true
                    } as LenderContactModel;

                    this.addUserToLender(this.lenderContact);

                } else {
                    this.router.navigate(['/account/users']);
                }
            },
            error => this.handleRegisterError(error)
        );
    }

    private handleRegisterError(error: Result) {
        this.errors = error.errorList;
    }

    addUserToLender(lenderContact): void {
        this.lendersService.addContact(lenderContact).subscribe(
            result => {
                this.showContactAddForm = false;
                this.showContactDetails = true;
                this.load();
            },
            error => {
                this.errors = (<Result>error).errorList;
            }
        );
    }

    updateUserForLender(): void {
        if (this.exUser) {
            this.lendersService.updateContact(this.exUser).subscribe(
                result => {
                    this.showContactEditForm = false;
                    this.showContactDetails = true;
                    this.exUser = null;
                    this.load();
                },
                error => {
                    this.errors = (<Result>error).errorList;
                }
            );
        }

    }

    editLenderContact(id): void {
        this.exUser = this.lenderContacts.find(x => x.id === id);
        this.showContactDetails = false;
        this.showContactEditForm = true;
    }
    cancelEditContact(): void {
        this.showContactDetails = true;
        this.showContactEditForm = false;
        this.showContactAddForm = false;
    }

    showAddUserForm(): void {
        this.showContactDetails = false;
        this.showContactEditForm = false;
        this.showContactAddForm = true;

    }
    hideAddUserForm(): void {
        this.showContactDetails = true;
        this.showContactEditForm = false;
        this.showContactAddForm = false;

    }
    confirmDeleteContact(): void {
        if (this.exUser) {
            this.lendersService.deleteContact(this.exUser.id).subscribe(
                result => {
                    this.showContactEditForm = false;
                    this.showContactDetails = true;
                    this.exUser = null;
                    this.load();
                    this.infoMessage = true;
                    this.infoMessageText = "Lender Contact Deleted";
                },
                error => {
                    this.errors = (<Result>error).errorList;
                }
            );
        }
    }

}
